import * as Styled from '../../policy.styled';

function TermsOfServiceJa() {
  return (
    <Styled.MainWrapper>
      <h3>第1章 総則</h3>
      <p>第1条 目的</p>
      本約款は、株式会社BubbleTap(以下「当社」といいます)が提供するTingle、リワード(Reward)など、すべてのサービス(以下「サービス」といいます)の利用と関連し、利用者の権利、義務及び責任事項などを規定することを目的とします。
      <br />
      <br />
      当社が提供するサービスを使用することにより、利用者(第2条用語の定義参照)は、利用約款及び当社が定める方針に同意及び受諾するものとみなします。
      <p>第2条 用語の定義</p>
      <ol>
        ① 本約款で使用する用語の定義は次のとおりです。
        <li>「利用者」とは、当社が提供するサービスを利用する会員と非会員のことです。</li>
        <li>「会員」とは、本約款および個人情報の提供に同意し、サービス利用資格を付与された対象者を意味します。</li>
        <li>
          「コンテンツ」とは、当社が提供するサービスに関連して掲示または提供した、そして生成された内容物すべてを意味します。
          これには人工知能(以下、AI)を使用して製作または生成したキャラクター、叙事、テーマ、文書、テキスト、対話、写真、情報,イメージ,ビデオ,音声ノート,音楽,デザイン,アルゴリズム,プロンプトなど(まとめて&quot;アセット&quot;),すべて含まれています。
        </li>
        <li>
          「入力メッセージ」とは、利用者が当社のTingleサービスを利用し、アセットを活用するためのテキストを意味します。
        </li>
        <li>「出力メッセージ」とは、利用者の入力メッセージに基づいてTingleサービスが出力したテキストを意味します。</li>
        <li>「有料サービス」とは、「当社」が有料で提供するコンテンツおよび諸サービスを意味します。</li>
        <li>
          「アクセス機器」とは、PC、携帯電話、タブレットなどを意味し、これに限らず、今後開発されるコンテンツなど、情報アクセスのツールとして使用される如何なる形のハードウェア、機器などの有形物を意味します。
        </li>
        <li>
          「掲示物」とは、会員がサービスを利用するにあたってサービスに掲示した符号、テキスト、文字、イメージ、音声、音響、画像、動画などの情報形態の文章·絵·写真·動画および各種ファイル·リンクなどを意味します。
          利用者がAIコンテンツを当社のプラットフォームに制作または生成するためのプロンプト、紹介文、説明、画像、紹介文などを含みます。
        </li>
        <li>
          「アプリ内通貨」とは、会員が当社が提供するアプリやプラットフォーム内で獲得、購入、または受け取ることができる仮想通貨の形態です。
          「アプリ内通貨」はアプリ内で当社が提供する有料サービスと交換できる手段です。
        </li>
      </ol>
      ②
      本約款で使用する用語の定義は、本条第1項各号に定めるものを除き、個別利用約款、サービスガイド、関係法令、その他の一般相関例によります。
      <p>第3条 個人情報等の提供</p>
      当社は個人情報処理方針、商号、代表者氏名、住所、電話番号·電子メールアドレス、事業者登録番号、通信販売業届出番号、カスタマーサポートなどを会員が簡単に分かるようにサービス初期画面に掲示します。
      <p>第4条 約款の掲示と改正</p>
      <ol>
        ①
        当社は、この約款の内容を会員が簡単に分かるように、サービス初期画面内または別途の接続画面に掲示したり、ポップアップ画面などで提供します。
        <br />
        <br />②
        当社は、情報通信網利用促進及び情報保護等に関する法律、電子商取引等における消費者保護に関する法律、約款の規制に関する法律等、関連法に違反しない範囲で本約款を改正することができます。
        <br />
        <br />③
        当社は、約款を改正する場合には、適用日及び改正理由を明示し、現行の約款とともに第1項の方式に従って、その改正約款の適用日の7日前から適用日の前日まで告知します。
        ただし、会員に不利な約款改正の場合には、適用日の30日前に告知し、会員が利用時に提供した電子メール、サービス内ポップアップ画面などの電子的手段を通じて別途明確に通知するようにします。
        <br />
        <br />
        ④
        当社は、前項により改正約款を公示または通知し、会員に7日または30日の期間内に拒否の意思表示をしなければ、約款改正に同意したものとみなすという旨を明確に公示または通知したにもかかわらず、会員が明示的に拒否の意思表示をしなかった場合、会員が改正約款に同意したものとみなします。
        <br />
        <br />⑤
        会員が改正約款の適用に同意しない場合、当社は改正約款の内容を適用することができず、この場合、会員は利用契約を解約することができます。
        ただし、既存の約款を適用できない特別な事情がある場合には、当社は利用契約を解約することができます。
      </ol>
      <p>第5条 約款の解釈</p>
      ①
      当社は、本約款以外に別途の利用約款及びポリシー(以下、「個別約款等」という)を設けることができ、当該内容が本約款と相反する場合には、個別約款等が優先して適用されます。
      <br />
      <br />
      ② 本約款で定められていない事項や解釈については、個別約款等及び関係法令又は慣行に従います。
      <br />
      <br />③
      当社が著作権者などコンテンツ提供者から利用または使用を許可され、会員の利用に提供する有料サービスに対しては、コンテンツ提供者の国籍国家の法および条約が適用されることがあります。
      <p>第6条 利用契約等締結</p>
      <ol>
        ① 利用契約は、利用者が当社が提供するサービスを使用することによって締結されます。
        また、利用契約は会員になろうとする者(以下、&quot;加入申請者&quot;という)が約款の内容について同意をした上で会員加入申請を行い、当社がこれらの申請に対して承諾することにより締結されます。
        <br />
        <br />
        ② 当社は加入申請者の申請に対してサービス利用を承諾することを原則とします。
        ただし、14歳未満の児童が法定代理人(親権者等)の同意を得なかったり、利用者の帰責事由により承認が不可能な場合、実名でなかったり他人の名義を利用した場合、当社会員資格を喪失した場合、その他本約款の諸般事項に違反した場合などに該当する申請に対しては承諾をしなかったり事後に利用契約を解約することができます。
        <br />
        <br />
        ③ 第1項による申請において、当社は専門機関を通じた実名確認及び本人認証を要請することができます。
        <br />
        <br />
        ④ 当社はサービス関連設備の余裕がない場合、技術上または業務上の問題がある場合には承諾を留保することができます。
        <br />
        <br />
        ⑤ 第2項と第4項により会員加入申請の承諾をしない場合、留保した場合、当社は原則としてこれを加入申請者に知らせます。
        <br />
        <br />
        ⑥
        利用契約の成立時期は、当社が加入完了を申請手続き上で表示した時点と定め、有料サービス利用契約の場合は、購入完了を申請手続き上で表示した時点と定めます。
        <br />
        <br />
        ⑦
        当社は会員に対して当社の方針によって等級別に区分し、利用時間、利用回数、サービスメニューなどを細分化して利用に差をつけることができます。
        <br />
        <br />
        ⑧
        当社は会員に対して青少年保護の関連法令、映画及びビデオ物の振興の関連法令などによる等級及び年齢遵守のために利用制限や等級別制限をすることができ、成人認証手続きを経るようにすることができます。
        <br />
        <br />
        ⑨
        会員が有料サービスを利用するためには、本約款および当該有料サービスに対する個別約款などに同意した後、有料サービスの利用条件に従って利用料金を支払わなければなりません。
        <br />
        <br />⑩
        当社は満18歳未満の未成年会員が有料サービスを利用しようとする場合に親権者など法定代理人の同意を得たり、契約締結後に追認を得たりしなければ未成年者本人または法定代理人がその契約を取り消すことができるという内容を契約締結前に告知する措置を取ります。
      </ol>
      <p>第7条 会員情報の変更</p>
      <ol>
        ①
        会員は、本約款に基づいて当社に情報を提供しなければならない場合には、真実の情報を提供しなければならず、虚偽の情報提供によって発生した不利益については保護されません。
        <br />
        <br />
        ②
        会員は、会員登録申請時に記載した事項が変更された場合、オンラインで修正するか、電子メールその他の方法で当社にその変更事項を知らせなければなりません。
        <br />
        <br />③
        前項の変更事項を当社に知らせなかったために発生する会員及びその他の第三者の不利益について、当社は責任を負いません。
      </ol>
      <p>第8条 個人情報保護義務</p>
      当社は、個人情報の関係法令の定めるところにより、会員の個人情報を保護するために努力します。
      個人情報の保護および使用については、関連法および当社の個人情報処理方針が適用されます。
      ただし、当社の公式サイト以外のリンクされたサイトでは、当社の個人情報処理方針が適用されません。
      <p>第9条 会員のID及びパスワードの管理に対する義務</p>
      <ol>
        ① 会員のIDとパスワードに関する管理責任は会員にあり、これを第三者が利用できるようにしてはなりません。
        会員は、IDの下で発生するすべての活動に対して責任があります。
        <br />
        <br />
        ②
        当社は、会員のIDが個人情報流出の恐れがあったり、反社会的または公序良俗に反する場合、当社関係者およびサービスの運営者と誤認される恐れがある場合、直接当該IDの利用を制限することができます。
        <br />
        <br />
        ③
        会員は、ID及びパスワードが盗用されたり、第三者が使用していることを認知した場合には、これを直ちに当社に通知し、当社の案内に従わなければなりません。
        <br />
        <br />
        ④
        第3項の場合、当該会員が当社にその事実を通知しなかったり、通知した場合にも当社の案内に従わなかったために発生した不利益に対して当社は責任を負いません。
        <br />
        <br />⑤ 利用規約または当社のポリシーに違反したと疑われる場合、当社が会員のIDを終了または制限することができます。
      </ol>
      <p>第10条 会員への通知</p>
      <ol>
        ①
        当社が会員に対する通知をする場合、この約款に別途規定がない限り、サービス内の電子メールアドレス、電子メッセージ、ログイン時のポップアップ画面などで行うことができます。
        <br />
        <br />②
        当社は、会員全体に対する通知の場合、7日以上サービス内掲示板、ポップアップ画面などに掲示することにより、前項の通知に代えることができます。
        ただし、会員本人の取引に関して重大な影響を及ぼす事項については、前項の通知をします。
      </ol>
      <p>第11条 当社の義務</p>
      <ol>
        ①
        当社は関連法とこの約款および個別約款などが禁止されたり、公序良俗に反する行為をせず、継続的かつ安定的にサービスを提供するために最善を尽くして努力します。
        <br />
        <br />
        ②
        当社は、会員が安全にサービスを利用できるように、個人情報(信用情報を含む)保護のためにセキュリティシステムを備え、個人情報処理方針を公示し、遵守します。
        <br />
        <br />
        ③
        当社は、サービス利用に関連して発生する利用者の不満または被害救済の申立てを適切に処理できるように必要な人材およびシステムを備えています。
        <br />
        <br />
        ④
        当社は、サービス利用に関して会員から提起された意見や不満が正当だと認められる場合には、これを処理しなければなりません。
        会員が提起した意見や不満事項については、掲示板を活用したり、電子メールなどを通じて会員に処理過程および結果を伝達します。
        <br />
        <br />⑤
        当社は、会員または利用者の不法または当社が禁止する行為によって発生するいかなる被害や損傷に対しても責任を負いません。
      </ol>
      <p>第12条 会員の義務</p>
      <ol>
        ① 会員は、次の行為をしてはなりません。
        <li>申請または変更時、虚偽の内容の登録</li>
        <li>他人の情報盗用</li>
        <li>当社が掲示した情報の修正、変更、翻訳、または適用</li>
        <li>当社が定めた情報以外の情報（コンピュータプログラム等）等の送信又は掲示</li>
        <li>当社のサービスを構成するプロンプト、ソフトウェア、または資料のソース コードを再構成する</li>
        <li>当社サービスのセキュリティ機能や使用制限を迂回または妨害</li>
        <li>当社または第三者のデータ、システム、またはネットワークへの不正アクセス、損傷、無効化、妨害、過負荷</li>
        <li>当社または第三者に実質的な被害または損傷または損害をもたらす行為</li>
        <li>当社やその他の第三者による著作権などの知的財産権の侵害</li>
        <li>当社やその他の第三者の名誉を傷つけ、又は業務を妨害する行為</li>
        <li>
          わいせつまたは暴力的なメッセージ、画像、音声その他の公序良俗に反する情報をサービスに公開または掲示する行為
        </li>
        <li>当社の同意なしに営利目的でサービスを利用する行為</li>
        <li>会員アカウントを本人以外の第三者に利用させる行為</li>
        <li>当社及び会員が属している国の法律に反する行為</li>
        <li>その他の不法または不当な行為</li>
      </ol>
      ②
      会員及び利用者は、テキストメッセージ、音声メッセージ、画像、ビデオ、アセットなどを通じて生成したコンテンツ及び掲示物について、全面的に責任を負います。
      会員及び利用者は当社のサービスを使用し、生成されたAIの出力物に対して全面的に責任を負います。
      会員及び利用者は、当社のAIサービスの使用において、利用約款、当社の方針、及び関連法を遵守することに同意し、当社が禁止した又は不法行為によって発生するすべての責任を負います。
      <br />
      <br />
      ③
      会員または利用者は、当社のAIサービスを利用することで、該当サービスで生成される出力テキスト、文書、イメージ、映像、音声、音楽、デザインなどがAIの生成物であることを認知するものとみなします。
      当社は当社のAIサービスによって生成された結果物、コンテンツ、またはアセットの正確性または事実の有無を保障しません。
      <br />
      <br />④
      会員は、関係法令、本約款及び運営方針、個別約款等の規定、利用案内及びサービスに関して告知した注意事項、当社が通知する事項、その他の当社の業務に支障をきたす行為をしてはなりません。
      当社は、これを遵守しない会員または利用者のアカウントを停止または終了することができます。
      アカウントの停止または終了時に、当該会員または利用者の掲示物またはコンテンツを削除することができます。
      <p>第13条 有料サービスの内容等の表示</p>
      <ol>
        ① 当社は次の事項を当該有料サービスの利用初期画面やFAQ等に会員が分かりやすく表示します。
        <li>有料サービスの名称又は呼称</li>
        <li>有料サービス主体の氏名（法人の場合は法人の名称）、住所、電話番号</li>
        <li>有料サービスの内容、利用方法、利用料その他の利用条件</li>
        <br />
        ② 当社の有料サービスの利用可能機器及び利用に必要な最小限の技術事項は、推奨環境情報に従います。
        <br />
        <br />
        ③
        当社は有料サービスを提供するにあたり、有料サービスの交換·返品·保証とその代金払い戻しの条件および手続きに関する事項を提供します。
        利用約款第19条参照。
        <br />
        <br />④
        当社が提供する有料サービスの利用券または商品券などは、当社外の第三者(当社の系列会社を含む)を通じて販売される場合があります。当該販売商品の利用方式、契約の申込みの撤回および払い戻しなどは、各提携会社が提供する有料サービスの利用約款およびポリシーに従います。
      </ol>
      <p>第14条 サービスの提供、中断及び変更</p>
      <ol>
        ① 当社はサービスを一定範囲に分割し、各範囲ごとに利用可能時間を別途指定できます。
        ただし、このような場合には、その内容を事前に告知します。
        <br />
        <br />
        ② サービスは年中無休、1 日 24 時間提供されることを原則としています。
        <br />
        <br />
        ③
        当社は、コンピュータ等の情報通信設備の保守点検、交換及び故障、通信の途絶又は運営上相当な理由がある場合、サービスの提供を一時的に中断することができます。
        この場合、当社はこの約款で定めた方法で会員に通知します。
        ただし、当社が事前に通知できないやむを得ない事由がある場合は、事後に通知することができます。
        <br />
        <br />
        ④
        当社は、サービスの提供に必要な場合、定期点検を実施することができ、定期点検時間はサービス提供画面に告知したとおりです。
        <br />
        <br />
        ⑤
        事業種の転換、事業の放棄、分割·合併などの理由で有料サービスを提供できなくなる場合には、本約款で定めた方法で会員に通知し、当初提示した条件に従って会員に補償します。
        <br />
        <br />⑥
        当社は、相当な理由がある場合に、運営上、技術上の必要に応じて提供している全部または一部のサービスを変更することができ、当該サービスの初期画面に関連事項を掲示します。
        ただし、有料サービスを変更する場合で、変更された内容が重大または会員に不利な場合には、本約款で定めた方法で通知し、必要な場合は本約款で定めたところに従って会員に補償します。
      </ol>
      <p>第15条 情報の提供及び広告の掲載</p>
      <ol>
        ①
        当社は、会員がサービス利用中に必要と認められる様々な情報をお知らせや電子メールなどの方法で会員に提供することができます。
        ただし、会員は関連法に基づく取引関連情報および顧客の問い合わせなどに対する回答などを除いては、いつでも電子メールなどに対して受信を拒否することができます。
        <br />
        <br />
        ② 第1項の情報を電子的な方法により送信する場合には、会員の事前同意を得て送信します。
        ただし、会員様の取引関連情報及びお客様へのお問い合わせなどに対する返信は、事前の同意なしに送信します。
        <br />
        <br />
        ③
        利用者が当社がサービスするコンテンツ及び当社の円滑なサービス利用のためのアップデート通知を申請する場合、当社は電子メール、SMS、アプリプッシュ(App
        Push)、電子メッセージなど電子的手段を通じて利用者に情報を提供(以下「アップデート通知」という)します。
        <br />
        <br />
        ④ 更新通知の内容は、当社のサービス ポリシーによって変更、削除、または追加される場合があります。
        <br />
        <br />
        ⑤ 利用者はいつでも設定画面から変更することでアップデート通知機能を解除することができます。
        この場合、当社はユーザーに更新通知を送信しません。
        <br />
        <br />
        ⑥
        当社はサービス画面、ホームページなどに直接、株式会社BubbleTapまたは提携関係にある第三者を通じて広告を掲載することができます。
        <br />
        <br />
        ⑦ 当社は、会員が事前に同意した場合に限り、電子メール、SMS、アプリプッシュ(App
        Push)、電子メッセージなど電子的手段を通じて広告性情報を送信することができます。
        広告性情報を受信した会員は、希望しない場合、いつでも受信を拒否することができ、当社は会員の受信拒否時に広告性情報を送信しません。
        <br />
        <br />⑧
        会員は当社が提供するサービスに関して掲示物またはその他の情報を変更、修正、制限するなどの措置をとりません。
      </ol>
      <p>第16条 掲示物の著作権</p>
      <ol>
        ① 会員がサービス内に掲示した掲示物の著作権は、当該掲示物の著作者に帰属します。
        会員は、会員の掲示物及び入力メッセージに関して、当社に利用規約に従って使用権またはライセンスを提供します。
        この使用権は著作権の移転を意味しません。
        会員の掲示物に対する著作権の範疇には、当該掲示物の製作または生成のために当社が会員に提供した技術、ツール、ソフトウェア、プラットフォームデザイン、出力メッセージなどが含まれていません。
        当社の明示的な許可なしに当社の知的財産権を複製、修正、配布、使用することはできません。
        <br />
        <br />
        ②
        利用者または会員は、当社のプラットフォームに掲示物を登録することにより、当社に当該掲示物に対する制限的使用権を許可します。
        利用者または会員が当社のサービスを利用することによって当社に付与する使用権は非独占的なものとします。
        当該使用権は、当社によって非独占的に譲渡またはサブライセンスが可能であり、2次著作物の生成、モデル研究開発および学習など、様々な商業的用途で使用されることがあります。
        利用者または会員がサービス内に掲示する掲示物は、当社の現在および未来サービス、新しい媒体または言語への転換など、当社サービスの拡張のためのマーケティング、広報、およびプロモーションなどに露出(当該露出のために必要な範囲内での一部修正、複製、編集を含む)されることがあります。
        また、利用者または会員の掲示物は、当社、コンテンツ及びサービスの改善と新しいコンテンツ及びサービス提供のための研究開発目的として活用することができます。
        <br />
        <br />
        ③
        利用者または会員は、当社のサービスを使用しながら当社のAIサービスによって生成されたコンテンツ(出力メッセージ、テキスト、イメージ、音声、音楽、BGM、動画など)に対する著作権を適用される法令に従い有するものとします。利用者または会員は、当社のサービスを利用することにより、当社に生成コンテンツに対する非独占的、制限的使用権を許可します。
        当該使用権は、当社によって非独占的に譲渡またはサブライセンスが可能であれば、2次著作物の生成、モデル研究開発および学習など、多様な商業的用途で使用されることがあります。
        利用者または会員が当社のサービスを使用することによって生成されるコンテンツは、当社の現在および未来サービス、新しい媒体または言語への転換など、当社のサービス拡張のためのマーケティング、広報、およびプロモーションなどに露出(当該露出のために必要な範囲内での一部修正、複製、編集を含む)されることがあります。
        また、ユーザーまたは会員が作成したコンテンツは、当社、コンテンツおよびサービスの改善と新しいコンテンツおよびサービス提供のための研究開発目的として活用することができます。
        <br />
        <br />
        ④
        利用者または会員が本人の掲示物を当社のサービスから削除または非公開処理をしても、当社に提供した制限的使用権(②項参照)は維持されます。
        <br />
        <br />
        ⑤
        当社が第2項以外の方法で会員の掲示物を利用しようとする場合には、電話、FAX、電子メールなどを通じて事前に会員の同意を得なければなりません。
        <br />
        <br />⑥
        会員は当社のサービスを利用することで、会員のすべての掲示物及び入力メッセージに対する権利、権限、ライセンス、または著作権を保有していることを当社に保証します。
      </ol>
      <p>第17条 投稿物の管理</p>
      <ol>
        ①
        会員の投稿物に情報通信網利用促進および情報保護などに関する法律、関連法に違反する内容が含まれた場合、権利者は関連法が定めた手続きに従って該当投稿物の投稿中断および削除などを要請することができ、当社は関連法に従って措置を講じなければならない。
        <br />
        <br />
        ②
        当社は、前項による権利者の要請がない場合であっても、権利侵害が認められるような事由があったり、その他の当社の方針及び関連法に違反する場合には、関連法に基づき当該投稿物に対して臨時措置などを取ることができます。
        したがって、当社は会員または利用者のコンテンツまたは投稿を検閲および削除できます。
        また、当社は内部判断により、当該会員または利用者のアカウントを停止または削除することができます。
        <br />
        <br />③
        本条による詳細な手続きは、情報通信網利用促進及び情報保護等に関する法律、著作権に関する法律が規定した範囲内で当社が定めた投稿中断要請サービスに従います。
      </ol>
      <p>第18条 権利の帰属</p>
      <ol>
        ① サービスに対する著作権及び知的財産権は当社に帰属します。
        ただし、会員の掲示物及び提携契約に基づいて提供された著作物などは除きます。
        <br />
        <br />②
        当社は、サービスと関連して会員に当社が定めた利用条件に従ってアカウント、ID、情報、決済手段などを利用できる利用権のみを付与し、会員は当社が許可しない限りこれを譲渡、販売、担保提供などの方法で処分してはなりません。
      </ol>
      <p>第19条 支払方法及び払戻し</p>
      <ol>
        ①
        会員は次の各号の方法で有料サービスを利用することができ、当社はサービス運営上の理由やコンテンツ提供者との契約などにより、一部のコンテンツに対してはその中の一部の方法だけを決済手段として提供することができます。
        但し、会員が選択した決済手段の提供者が別途に存在する場合、会員は当該決済手段を利用する前に当該決済手段で要求される手続きを履行しなければ、当該決済手段を利用して決済を進めることができず、当該決済手段を利用した決済に関しては、会員が当該決済手段の提供者との間で締結した契約条件が適用されます。
        <li>アプリマーケット(Google Play ストア)アプリ内決済</li>
        <li>アプリマーケット(App Store)アプリ内決済</li>
        <li>トス·ペイメント株式会社 ウェブ決済</li>
        <li>その他当社が定めた決済手段</li>
        <br />
        ②
        当社のポリシーおよび第1項の決済方法提供者が定めた基準により、会員の月別累積決済額および有料サービスの購入限度が制限されることがあります。
        該当基準を超えた場合、有料サービスの追加利用は不可能になることがあります。
        会員が当社のアプリ内通貨をカード決済する際、カード会社が決済金額を一定金額以下に制限したり、決済ができないことがあります。
        <br />
        <br />
        ③ 当社のアプリ内通貨は会員間の譲渡が不可能です。
        <br />
        <br />④ 当社内部のアプリ内通貨の有効期限は次の通りです。
        <ol>
          <li>購入した当社のアプリ内通貨を使用できる期限は最大1年です。</li>
          <li>無料で会員に支給された当社の無料アプリ内通貨を使用できる期限は最大1年以内です。</li>
        </ol>
        ⑤ 決済のキャンセルと払い戻し
        <ol>
          <li>当社のアプリ内通貨を購入した後の払い戻しはアプリ内通貨を購入するために使用した決済手段で行われます。</li>
          <li>当社のアプリ内通貨の払い戻し要請できる期限はアプリ内通貨購入時点から7日以内です。</li>
          <li>
            当社と購入に関する契約を締結した会員は、以下のように決済に対するキャンセル及び払い戻しを要求することができます。
            <ol>
              <li style={{ listStyleType: 'lower-alpha' }}>
                当社のアプリ内通貨を購入した後、当該アプリ内通貨パッケージの有料アプリ内通貨または無料で支給されたアプリ内通貨の一部を使用した後、未使用のポイントに対して決済の取り消し及び払い戻しを行うことができません。
                つまり、購入した当社のアプリ内通貨パッケージに対する部分払い戻しは不可能です。
              </li>
              <li style={{ listStyleType: 'lower-alpha' }}>
                当社のアプリ内通貨パッケージを購入した後、当該パッケージに含まれた有料アプリ内通貨及び無料アプリ内通貨を使用していない場合、当該パッケージ購入時点で決済された金額に応じてキャンセル及び払い戻しされます。
              </li>
            </ol>
          </li>
          <li>
            当社の責に帰すべき事由により決済エラーが発生した場合、決済に対するキャンセル及び払い戻しを要求することがあります。
            本利用規約の第23条を参照してください。
          </li>
          <li>
            当社の責に帰すべき事由によりサービスが中断される場合、決済に対するキャンセル及び払い戻しを要求することがあります。
            本利用規約の第14条を参照してください。
          </li>
        </ol>
      </ol>
      <p>第20条 会員の申込みの撤回等、契約解除及び会員脱退</p>
      <ol>
        ①
        会員はいつでもサービス初期画面のカスタマーサポートまたはマイ情報管理メニューなどを通じて利用契約解約申請または会員脱退をすることができ、当社は関連法などが定めるところに従ってこれを直ちに処理しなければなりません。
        <br />
        <br />
        ②
        会員が契約を解約または退会する場合、関連法および個人情報処理方針に従って当社は会員情報を保有しなければならない場合を除き、解約後直ちに会員のすべての情報は破棄します。
        <br />
        <br />
        ③
        会員が契約を解約または退会する場合、会員が作成した投稿物のうち、本人のアカウントに登録された投稿物は削除されないことがあります。
        特に、会員が生成したAIキャラクター、叙事、テーマなどは削除されません。
        第三者によって書き込み、スクラップなどになって再投稿されたり、公開掲示板に登録された投稿物は削除されませんので、事前に削除してから退会してください。
        <br />
        <br />④
        有料サービス利用契約を締結または当社のアプリ内通貨を購入した会員は、当社の内部方針及び関連法令で定めるところにより、一定期間内に申込みを撤回したり、当該契約を解除(以下「契約撤回等」という)することができます。
        ただし、次の各号の場合には、契約撤回などが制限されます。
        <ol>
          <li>
            会員が当社のアプリ内通貨を有料で購入した後、当該アプリ内通貨の払い戻し不正利用(サービス運営方針第6条参照)をすると当社が判断した場合
          </li>
          <li>
            会員が当社のアプリ内通貨を有料で購入した後、当該アプリ内通貨の有料または無料分の一部を使い果たした後、アプリ内通貨の残額に対して契約の撤回または払い戻しを試みる場合
          </li>
          <li>会員が当社が支給した無料のアプリ内通貨に対して申込み期間または払い戻しを試みる場合</li>
          <li>
            会員に責任のある事由により商品等が滅失し、又は毀損された場合。
            商品などの内容を確認するために包装などを毀損した場合
          </li>
          <li>会員の使用または一部消費により商品などの価値が著しく減少した場合</li>
          <li>時間の経過により再販売が困難になるほど商品などの価値が著しく減少した場合</li>
          <li>
            複製が可能な商品等の包装を毀損した場合とは、関係法令に基づきデジタルコンテンツの提供が開始された場合を指します。ただし、分割して提供されるコンテンツについては、未提供の部分についてはこの限りではありません。
          </li>
          <li>
            会員の注文により個別に生産される商品等またはこれに類似した商品等に対して契約の申込みの撤回などを認める場合、株式会社BubbleTapに回復できない重大な被害が予想される場合で、事前に当該取引に対して別途その事実を告知し、会員の書面(電子文書を含む)による同意を得た場合
          </li>
        </ol>
        ⑤
        会員は、前項にもかかわらず、当社の有料サービスの内容が表示·広告の内容と違ったり、契約内容と異なって履行された場合には、その商品などの供給を受けた日から3ヶ月以内、その事実を知った日または分かった日から30日以内に契約撤回などをすることができます。
        <br />
        <br />⑥ 会員は、次の各号の場合、有料サービス利用契約を解約または解除することができます
        <ol>
          <li>有料サービスの欠陥が補完·修正できない場合、有料サービスの供給を受けた日から1ヶ月以内</li>
          <li>会員が本約款の変更に同意しないため、会員退会または有料サービス利用契約を解約する場合</li>
        </ol>
        ⑦ 第1項及び第2項による当社と会員の返品·交換·払い戻し·取消に関する事項は、第21条で定めるところによります。
      </ol>
      <p>第21条 契約の申込みの撤回等及び契約解除の効果</p>
      <ol>
        ①
        当社は会員が契約解除など、契約解除の意思表示をした日から3営業日以内に払い戻し決定を会員に通知しなければならず、払い戻し決定後3営業日以内に代金の決済と同じ方法でこれを払い戻ししなければならず、同じ方法で払い戻しが不可能な時にはこれを事前に告知しなければなりません。
        ただし、入金確認を要する決済手段の場合は、入金確認日から3営業日以内に返金を行うことがあります。
        <br />
        <br />
        ② 会員の契約の申込みの撤回及び契約解除は、利用約款第19条及び第20条により制限されることがあります。
        <br />
        <br />
        ③
        当社が払い戻しの際、会員がクレジットカードまたは電子決済手段などの決済手段で商品などの代金を支払ったときは、遅滞なく当該決済手段を提供した事業者に商品などの代金の請求を停止または取り消すよう要請します。
        ただし、第1項ただし書及び第2項の場合は、この限りでないことがあります。
        <br />
        <br />
        ④
        当社の有料サービスの代金を受け取った者または会員と有料サービス利用契約を締結した者が同一人物でない場合、各自は契約の申込みの撤回などに関する義務の履行において連帯して責任を負います。
        <br />
        <br />⑤
        当社は、アプリマーケット決済(アプリ内決済)およびウェブ決済において、当該アプリマーケットおよびウェブ決済会社に対して代金支給の停止·取り消し要請など、電子商取引等における消費者保護に関する法律に基づく関連措置をとります。
        ただし、上記のような当社の要請による当該アプリマーケットの措置については、当該アプリマーケットのポリシーを参照してください。
      </ol>
      <p>第22条 当社の契約解除、解約及び利用制限等</p>
      <ol>
        ①
        当社は、会員がこの約款、個別約款などに違反したり、サービスの正常な運営を妨害することが合理的に疑われたり、明らかになった場合、警告、一時停止、永久利用停止などでサービス利用を段階的に制限することができます。
        ただし、このような利用制限にもかかわらず、これ以上サービス利用契約の完全な維持を期待することが難しい場合は、やむを得ず利用制限措置に加え、会員との利用契約を解除または解約することができます。
        <br />
        <br />
        ②
        当社は、会員が3ヶ月以上ログインしない場合、会員情報の保護及び運営の効率性のため、直接サービスの利用を制限することができます。
        <br />
        <br />
        ③
        第1項、第2項に関連してサービス利用を通じて獲得した会員の無償特典は消滅し、当社はこれに対して別途に補償しません。
        但し、会員の帰責事由により当社が利用契約を解除または解約する場合、会員の要請により有料サービス代金を払い戻ししますが、会員のIDが盗用されたりIDがコンテンツの無断複製·配布などを含むその他の不法行為に利用されるなど特別な事情がある場合には払い戻しまたは補償をいたしません。
        <br />
        <br />
        ④
        当社は第3項ただし書により払い戻しが必要な場合、第22条第1項を準用し、会員が有料サービス利用から得た利益及び払い戻し手数料(10%または100円のうち大きい金額)に該当する金額を払い戻しする金額から控除することができます。
        <br />
        <br />
        ⑤ 第1項の解除、解約は当社がこの約款で定めた通知方法に従って会員にその意思を表示した時に効力が発生します。
        <br />
        <br />⑥ 当社の解除、解約及び利用制限について、会員は当社が定めた手続きに従って異議申請をすることができます。
        この際、異議が正当であると認められる場合、当社は直ちにサービスの利用を再開します。
      </ol>
      <p>第23条 誤払い</p>
      <ol>
        ①
        当社は、誤払いが発生した場合、会員が決済した方法と同じ方法で払い戻しし、同じ方法で払い戻しが不可能な場合は、これを事前に告知します。
        <br />
        <br />
        ②
        当社の責任がある理由で誤払いが発生した場合は、誤払い全額を払い戻し、会員の責任がある理由で誤払いが発生した場合、当社が誤払いを払い戻しするのにかかる費用は合理的な範囲内で会員が負担しなければなりません。
        <br />
        <br />③ 当社は、誤払いの払い戻し手続きは、関連法令および当社の定める方針に従って処理します。
      </ol>
      <p>第24条 使用期間等</p>
      有料サービスの使用期間または有効期間は、事前に別途表示されない限り、取引日から1年です。
      当該期間が経過した有料サービスは、利用権限が消滅し、保有リストから削除されることがあります。
      <p>第25条 コンテンツ等の瑕疵に関する補償</p>
      有料サービスの瑕疵等による会員への補償については、関連法令および当社の定める方針に従い適切に対応します。
      <p>第26条 責任制限</p>
      <ol>
        ①
        当社は天災地変またはこれに準ずる不可抗力によりサービスを提供できない場合には、サービス提供に関する責任が免除されます。
        <br />
        <br />
        ② 当社は会員の帰責事由によるサービス利用の障害に対しては責任を負いません。
        <br />
        <br />
        ③
        当社は、会員がサービスと関連して掲載した、そして当社のAIサービスを通じて生成された情報、資料、結果値の信頼度、正確性、適法性、独創性、排他性、真実性·活用可能性·適合性を保障するものではありません。関連内容による会員または利用者の行為に責任を負いません。
        <br />
        <br />
        ④
        当社のAIサービスの情報、資料、結果値の利用に関して発生するすべての問題に対する責任は会員にあり、当社はこれに対して一切の責任を負いません。
        <br />
        <br />
        ⑤
        当社は、会員または利用者が掲示板に投稿した、または当社のサービスを使用して投稿した情報、資料、内容などに関して事実の正確性、信頼度などにいかなる責任も負わず、会員は本人の責任の下でサービスを利用しなければなりません。
        <br />
        <br />
        ⑥
        当社は、会員または利用者がサービス利用と関連して会員に発生した損害のうち、会員の故意、過失による損害及び他の会員によって被る精神的被害に対して補償する責任を負いません。
        <br />
        <br />
        ⑦
        当社は、会員間または会員と第三者相互間の当社のサービスを媒介として、コミュニケーション、通信、連絡、交際、取引などをした場合に発生したいかなる被害または損失に対しても責任が免除されます。
        <br />
        <br />
        ⑧ 当社は、サービスの利用に関して関連法がない限り、責任を負いません。
        <br />
        <br />
        ⑨ 会員は、本利用約款に違反して相手方に損害を与えた場合には、その損害を賠償する責任があります。
        ただし、故意または過失がない場合は、この限りではありません。
        <br />
        <br />
        ⑩
        会員が投稿または送信した資料などに関して損害が発生したり、資料の取捨選択と関連していかなる不利益が発生しても、これに対するすべての責任は会員にあります。
        <br />
        <br />⑪ 当社又は会員は、本約款に違反して相手方に損害を与えた場合には、その損害を賠償する責任があります。
        ただし、故意または過失がない場合は、この限りではありません。
      </ol>
      <p>第27条 準拠法及び合意管轄裁判所</p>
      <ol>
        ① 当社と会員間で提起された訴訟は、大韓民国法を準拠法とします。
        <br />
        <br />
        ②
        当社と会員の間で発生した紛争に関する訴訟は提訴当時の会員の住所により、住所がない場合は居所を管轄する地方裁判所の専属管轄とします。
        ただし、提訴当時、会員の住所または居所が明確でない場合の管轄裁判所は、民事訴訟法に基づいて定めます。
        <br />
        <br />③
        海外に住所や居所がある会員の場合、当社と会員の間で発生した紛争に関する訴訟は、前項にもかかわらず大韓民国ソウル中央地方裁判所を管轄裁判所とします。
      </ol>
      <br />
      ©2025 BubbleTap. All rights reserved.
    </Styled.MainWrapper>
  );
}

export default TermsOfServiceJa;
